import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    root: {
        marginBottom: 12, 
        width: '100%', 
        background: '#1b2039', 
        borderRadius: 8, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        flexDirection: 'column'
    },
    wrap: {
        position: 'relative', 
        display: 'flex', 
        flexDirection: 'column', 
        color: '#fff', 
        fontFamily: 'Montserrat, sans-serif', 
        fontSize: 18, 
        borderBottom: '1px solid rgba(0,0,0,.3)', 
        width: '100%', 
        textAlign: 'center', 
        paddingTop: 20, 
        paddingBottom: 20
    },
    icon: ({status}) => ({
        width: 5, 
        height: 5, 
        position: 'absolute', 
        top: 10, 
        left: 10, 
        background: status ? '#3cde0b' : 'rgb(255, 78, 68)', 
        borderRadius: '50%'
    }),
    wrapBtn: {
        display: 'flex', 
        justifyContent: 'center', 
        padding: '0 10px', 
        width: 'calc(100% - 20px)', 
        marginTop: 12
    },
    btn: {
        padding: '7px 10px', 
        width: '100%', 
        background: '#ebc015', 
        borderRadius: 8, 
        color: 'rgb(27, 32, 57)'
    }
}))

export {
    useStyles
}